import React from "react";

const CustomInput = ({
  id,
  label,
  register,
  error,
  inputClassName,
  ...rest
}) => {
  return (
    <>
      <div className="relative ">
        <input
          type="text"
          id={id}
          className={`${inputClassName} peer border border-gray_100 rounded-[10px] 2xl:py-[7px] py-1 px-4 w-full bg-white_50 placeholder-gray_600 placeholder:font-light focus:placeholder-transparent focus-visible:outline-primary_orange`}
          {...rest}
          {...register}
        />
        <label
          htmlFor={id}
          className="absolute top-[7px] left-3 bg-[rgb(255_255_255)] text-base font-normal text-primary_orange transition-all duration-300 transform -translate-y-1/2 scale-75 origin-left opacity-0 peer-focus:scale-75 peer-focus:-translate-y-5 peer-focus:opacity-100 peer-[:not(:placeholder-shown)]:scale-75 peer-[:not(:placeholder-shown)]:-translate-y-5 peer-[:not(:placeholder-shown)]:opacity-100"
        >
          {label}
        </label>
        {error && <p className="text-red-500 text-xs pt-2">{error?.message}</p>}
      </div>
    </>
  );
};

export default CustomInput;
